import { createAsyncThunk } from "@reduxjs/toolkit";
import { getPeriodicSurveys } from "../../config/services/ApiServices";

export const fetchPeriodicSurveys = createAsyncThunk('periodicSurveys-table/fetch', async ({ startDate, endDate, customerId, timeZone, assetId}: { startDate: Date, endDate: Date, customerId: string, timeZone?: any, assetId?:string,  }) => {
    const response = await getPeriodicSurveys({ startDate, endDate, customerId, timeZone, assetId });
    return response;
})

